import { render } from "./HeaderLocationReset.vue?vue&type=template&id=3f9b6355&ts=true"
import script from "./HeaderLocationReset.vue?vue&type=script&lang=ts"
export * from "./HeaderLocationReset.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/soctio/events/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__